import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { ProfileCacheService } from './profile-cache.service';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api-endpoints';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly router = inject(Router);
  private readonly http = inject(HttpClient);
  private readonly isAuthenticated = signal<boolean>(false);
  private readonly currentUser = signal<any>(null);
  private readonly apiService = inject(ApiService);
  private readonly profileCacheService = inject(ProfileCacheService);
  private readonly authBaseUrl = environment.authHost ?? environment.host;
  
  login(payload: any): Observable<any> {
    return this.apiService.post(API_ENDPOINTS.AUTH.LOGIN, payload);
  }

  getAzureLoginUrl(): Observable<{ success: boolean; authorizationUrl: string; state: string }> {
    return this.http.get<{ success: boolean; authorizationUrl: string; state: string }>(
      `${this.authBaseUrl}${API_ENDPOINTS.AUTH.AZURE_LOGIN_URL}`
    );
  }

  verifyAzureToken(accessToken: string, idToken?: string): Observable<{ success: boolean; message: string; staff: any }> {
    return this.http.post<{ success: boolean; message: string; staff: any }>(
      `${this.authBaseUrl}${API_ENDPOINTS.AUTH.AZURE_VERIFY}`,
      { accessToken, idToken }
    );
  }

  getStaffInfo(): Observable<any> {
    return this.apiService.get(API_ENDPOINTS.STAFF.INFO);
  }

  logout(): void {
    this.isAuthenticated.set(false);
    this.currentUser.set(null);
    this.profileCacheService.clearCache();
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('staffInfo');
    sessionStorage.removeItem('selectedLocation');
    sessionStorage.removeItem('oauthState');
    sessionStorage.removeItem('programId');
    sessionStorage.removeItem('tokenExchangeResponse');
    sessionStorage.removeItem('staff_enrollment_user_id');
    sessionStorage.removeItem('staff_enrollment_session_user_id');
    sessionStorage.removeItem('participant_auth_token');
    localStorage.removeItem('user_id');
    this.router.navigate(['/']);
  }

  getIsAuthenticated() {
    return this.isAuthenticated.asReadonly();
  }

  getCurrentUser() {
    return this.currentUser.asReadonly();
  }

  setCurrentUser(user: any): void {
    this.currentUser.set(user);
    this.isAuthenticated.set(true);
  }

  // Get staff info from sessionStorage if available
  getStoredStaffInfo(): any {
    const staffInfo = sessionStorage.getItem('staffInfo');
    if (staffInfo) {
      try {
        const parsed = JSON.parse(staffInfo);
        this.currentUser.set(parsed);
        this.isAuthenticated.set(true);
        return parsed;
      } catch {
        return null;
      }
    }
    return null;
  }
}
